export const mockRecipes = {
  recipes: [
    {
      uuid: "e80ea521-4d42-48fe-a7a6-ac8952bc0de4",
      title: "Queso Brat Scramble",
      description: "A delicious breakfast, fit for a crowd.",
      images: {
        full: "/img/queso_brat_scramble.jpg",
        medium:
          "https://lh3.googleusercontent.com/KTToql6W8SkbvOD9hosyHJ2x70B_muQSWrBcxt7_tmK73OowbpHIdw7GxdyBP75J2-U85jKtgzHcOK1wSR2CKQ=w1280-h1280-c-rw-v1-e365",
        small: "/img/queso_brat_scramble--s.jpg",
      },
      servings: 5,
      prepTime: 10,
      cookTime: 20,
      postDate: "01/20/2018 05:15:03 PM",
      editDate: "02/05/2018 11:56:29 PM",
      ingredients: [
        {
          uuid: "62798278-2fbc-4c31-98de-b7959c191688",
          amount: 1,
          measurement: "package (19 oz)",
          name: "queso brats",
        },
        {
          uuid: "2df619ea-8472-48f4-9615-3f387a492d22",
          amount: 8,
          measurement: "tablespoons",
          name: "canola oil",
        },
        {
          uuid: "fee4a89c-8c27-4073-9055-a0b052a1c079",
          amount: 4,
          measurement: "",
          name: "corn tortillas, cut into 1/2-inch squares",
        },
        {
          uuid: "6278b9e5-3862-44f8-97b0-5bd37bb70141",
          amount: 0.5,
          measurement: "",
          name: "small red onion, diced",
        },
        {
          uuid: "41785201-9596-4ebc-b8ea-1feb562ebc53",
          amount: 1,
          measurement: "",
          name: "small red pepper, diced",
        },
        {
          uuid: "34918edd-b5fd-475c-9a13-364632971938",
          amount: 1,
          measurement: "",
          name: "jalapeno pepper, seeded and chopped",
        },
        {
          uuid: "75fe2545-4053-40bd-9c4f-150b61a052fb",
          amount: 2,
          measurement: "cloves",
          name: "garlic, minced",
        },
        {
          uuid: "3d810ba9-7e4e-48aa-b2e9-7918e38b358d",
          amount: 8,
          measurement: "",
          name: "eggs",
        },
        {
          uuid: "7fbce07e-b640-4f36-8a7f-d094dc04d7d2",
          amount: 0.25,
          measurement: "cup",
          name: "half-and-half cream",
        },
        {
          uuid: "cdfa1350-3190-46b5-8f4d-4dfdadee7e39",
          amount: 1.5,
          measurement: "teaspoons",
          name: "chili powder",
        },
        {
          uuid: "210b15ac-552e-4450-b162-c0a41bb3389d",
          amount: 0.5,
          measurement: "teaspoon",
          name: "salt",
        },
        {
          uuid: "885293b6-50ae-4ffd-b6d4-32b795d96031",
          amount: 5,
          measurement: "dashes",
          name: "hot sauce, more to taste",
        },
        {
          uuid: "da6965ac-b6c4-4715-b3d5-2a24f236650a",
          amount: 1,
          measurement: "cup",
          name: "halved grape tomatoes",
        },
        {
          uuid: "5f79e3c0-f214-4226-a660-1049778355a8",
          amount: 0.5,
          measurement: "cup",
          name: "canned black beans, rinsed and drained",
        },
        {
          uuid: "86c9eb8e-3ff6-4d4f-83d7-ea4d9f1ae455",
          amount: 1,
          measurement: "cup",
          name: "pepper jack cheese, shredded",
        },
      ],
      directions: [
        {
          instruction:
            "Cook brats according to package directions. Cool slightly and halve and slice.",
          optional: false,
        },
        {
          instruction:
            "In a large skillet, over medium heat, heat 1/2 cup oil in a skillet, add tortilla squares; fry until crisp.",
          optional: false,
        },
        {
          instruction:
            "With a slotted spoon remove tortilla to a paper-towel lined plate to drain.",
          optional: false,
        },
        {
          instruction:
            "In another skillet, sauté the onion, pepper, jalapeno and garlic in the remaining 1 tablespoon oil.",
          optional: false,
        },
        {
          instruction: "Remove from pan and keep warm.",
          optional: false,
        },
        {
          instruction:
            "In a bowl, combine the eggs, cream, chili powder, salt and hot sauce. ",
          optional: false,
        },
        {
          instruction:
            "Pour into skillet; cook, stirring occasionally until set.",
          optional: false,
        },
        {
          instruction:
            "Add the brats, tomatoes, black beans and tortillas; heat through.",
          optional: false,
        },
        {
          instruction: "Sprinkle with cheese.",
          optional: true,
        },
        {
          instruction: "Serve immediately.",
          optional: false,
        },
      ],
    },
    {
      uuid: "7f8e872d-47a5-44e6-b1ad-7b7cb94f1d30",
      title: "Italian Meatballs",
      description: "Quick, easy and authentic.",
      images: {
        full: "/img/italian_meatballs.jpg",
        medium:
          "https://www.jocooks.com/wp-content/uploads/2012/11/italian-meatballs-1-2-1.jpg",
        small: "/img/italian_meatballs--s.jpg",
      },
      servings: 6,
      prepTime: 25,
      cookTime: 20,
      postDate: "02/19/2018 12:47:42 AM",
      editDate: "02/19/2018 01:12:05 AM",
      ingredients: [
        {
          uuid: "3d810ba9-7e4e-48aa-b2e9-7918e38b358d",
          amount: 1,
          measurement: "",
          name: "egg, lightly beaten",
        },
        {
          uuid: "6d5dce01-b305-4df1-875e-1354a048bcea",
          amount: 0.333,
          measurement: "cup",
          name: "dry bread crumbs",
        },
        {
          uuid: "0c62dd1d-7b0f-4471-ba06-df220177ae39",
          amount: 0.25,
          measurement: "cup",
          name: "parmesan cheese, grated",
        },
        {
          uuid: "aa1ff525-4190-4a66-8d12-3f383a752b55",
          amount: 0.25,
          measurement: "cup",
          name: "milk",
        },
        {
          uuid: "6278b9e5-3862-44f8-97b0-5bd37bb70141",
          amount: 0.25,
          measurement: "cup",
          name: "onion, finely chopped",
        },
        {
          uuid: "62798278-2fbc-4c31-98de-b7959c191688",
          amount: 1.25,
          measurement: "lbs",
          name: "ground italian sausage",
        },
      ],
      directions: [
        {
          instruction: "Preheat oven to 350°F.",
          optional: false,
        },
        {
          instruction:
            "In a large bowl, combine the egg, bread crumbs, grated parmesan cheese, milk and onion.",
          optional: false,
        },
        {
          instruction: "Add sausage to the bread crumb mixture and mix well.",
          optional: false,
        },
        {
          instruction:
            "Shape into 20 meatballs; arrange on a shallow baking pan.",
          optional: false,
        },
        {
          instruction:
            "Bake for 20 minutes or until meatballs are cooked through (160°F).",
          optional: false,
        },
        {
          instruction: "Serve with your favorite sauce and spaghetti.",
          optional: true,
        },
      ],
    },
    {
      uuid: "3555aec3-47e1-44d4-b8f2-607aad5cee67",
      title: "Kielbasa Skillet",
      description: "A polish delicacy.",
      images: {
        full: "/img/kielbasa_skillet.jpg",
        medium:
          "https://iamhomesteader.com/wp-content/uploads/2022/02/roasted-potato-kielbasa.jpg",
        small: "/img/kielbasa_skillet--s.jpg",
      },
      servings: 8,
      prepTime: 20,
      cookTime: 20,
      postDate: "03/12/2018 01:51:12 PM",
      editDate: "03/15/2018 04:14:03 PM",
      ingredients: [
        {
          uuid: "3d810ba9-7e4e-48aa-b2e9-7918e38b358d",
          amount: 1,
          measurement: "package (13.5 oz)",
          name: "kielbasa sausage",
        },
        {
          uuid: "6d5dce01-b305-4df1-875e-1354a048bcea",
          amount: 1,
          measurement: "cup",
          name: "carrot, sliced into small chunks",
        },
        {
          uuid: "6278b9e5-3862-44f8-97b0-5bd37bb70141",
          amount: 1,
          measurement: "",
          name: "large onion, coarsely chopped",
        },
        {
          uuid: "77ae45d7-659b-4cb5-a4ea-07f00e442974",
          amount: 2,
          measurement: "tablespoons",
          name: "butter",
        },
        {
          uuid: "efdc9267-cfbb-4e3e-90e2-1fe7287ed4e6",
          amount: 1,
          measurement: "",
          name: "small head of cabbage, cut into wedges",
        },
        {
          uuid: "e616c374-ed92-4b99-81c2-f73d180601e8",
          amount: 0.5,
          measurement: "teaspoon",
          name: "dried thyme",
        },
        {
          uuid: "210b15ac-552e-4450-b162-c0a41bb3389d",
          amount: 0.25,
          measurement: "teaspoon",
          name: "salt",
        },
        {
          uuid: "5fc6a47f-7ef4-48ab-a5d9-384417dc63cf",
          amount: 0.25,
          measurement: "teaspoon",
          name: "black pepper",
        },
        {
          uuid: "da4df371-eb5d-44f6-905c-6c10255b24b4",
          amount: 2,
          measurement: "packages (24 oz each)",
          name: "refrigerated prepared mashed potatoes",
        },
      ],
      directions: [
        {
          instruction:
            "In a large skillet, sauté sausage, carrot, and onion in butter until onion is tender.",
          optional: false,
        },
        {
          instruction:
            "Add the cabbage, thyme, salt, and pepper. Reduce heat; simmer, covered 14-16 minutes or until cabbage is tender.",
          optional: false,
        },
        {
          instruction:
            "Meanwhile, heat potatoes according to package directions.",
          optional: false,
        },
        {
          instruction: "Serve with sausage mixture.",
          optional: false,
        },
      ],
    },
    {
      uuid: "3555aec3-47e1-44d4-b8f2-607aad5cee69",
      title: "Brussel Chips",
      description: "Tasty, crispy, spicy and healthy!",
      images: {
        full: "/img/brussel_chips.jpg",
        medium:
          "https://www.saveur.com/uploads/2019/03/18/WDXMZ7OD2CTZUJO2QJ2SEVCRYM.jpg?auto=webp",
        small: "/img/brussel_chips--s.jpg",
      },
      servings: 4,
      prepTime: 15,
      cookTime: 25,
      postDate: "03/28/2018 01:27:51 AM",
      editDate: "03/30/2018 05:51:52 PM",
      ingredients: [
        {
          uuid: "77ae45d7-659b-4cb5-a4ea-07f00e442974",
          amount: 2,
          measurement: "tablespoons",
          name: "butter",
        },
        {
          uuid: "86b9842d-3025-4d27-82aa-459ef4f8ab7f",
          amount: 1.5,
          measurement: "teaspoons",
          name: "dijon mustard",
        },
        {
          uuid: "210b15ac-552e-4450-b162-c0a41bb3389d",
          amount: 0.25,
          measurement: "teaspoon",
          name: "salt",
        },
        {
          uuid: "3d6ee987-8ffd-479c-88e0-e3eca690704f",
          amount: 1,
          measurement: "pinch",
          name: "red pepper flakes",
        },
        {
          uuid: "95e5a38d-26db-4e90-9773-d6be11a280df",
          amount: 1,
          measurement: "pound",
          name: "brussel sprouts",
        },
      ],
      directions: [
        {
          instruction:
            "Place a rack in top position of your oven and preheat to 325 F.",
          optional: false,
        },
        {
          instruction: "Line a baking sheet with aluminum foil.",
          optional: false,
        },
        {
          instruction:
            "Trim the stems of the Brussels sprouts to release outermost leaves, about 5 leaves from each sprout.",
          optional: false,
        },
        {
          instruction:
            "Place leaves in the bowl of sauce; toss with your fingers until all the leaves are evenly coated.",
          optional: false,
        },
        {
          instruction: "Spread leaves on the baking sheet in a single layer.",
          optional: false,
        },
        {
          instruction:
            "Roast leaves in the preheated oven until wilted and lightly browned, about 15 minutes. Transfer any crispy leaves to a serving plate and continue roasting, removing crispy leaves at 5-minute intervals, until all leaves are crispy, about 10 minutes more.",
          optional: false,
        },
      ],
    },
    {
      uuid: "f8fc88dc-2f89-43fa-b431-00d90eeba521",
      title: "Pancake Mountain",
      description: "A giant stack of pancakes to share or to horde.",
      images: {
        full: "/img/pancake_mountain.jpg",
        medium:
          "https://www.visitglenarbor.com/wp-content/uploads/2023/02/Pancakes-SQ_8FCDABA8-5056-BF65-D63C6D0E8356400D_8fce6d5c-5056-bf65-d67b4080febc7caa-1.jpg",
        small: "/img/pancake_mountain--s.jpg",
      },
      servings: 8,
      prepTime: 15,
      cookTime: 20,
      postDate: "04/14/2018 07:28:54 PM",
      editDate: "04/17/2018 03:20:16 PM",
      ingredients: [
        {
          uuid: "aa1ff525-4190-4a66-8d12-3f383a752b55",
          amount: 1.5,
          measurement: "cups",
          name: "milk",
        },
        {
          uuid: "d4fbd3ee-add4-4e86-b8bb-898a97d5be78",
          amount: 4,
          measurement: "tablespoons",
          name: "white vinegar",
        },
        {
          uuid: "811a6f12-428e-4110-abcd-508e4080bc5c",
          amount: 2,
          measurement: "cups",
          name: "all-purpose flour",
        },
        {
          uuid: "28ed1238-648b-4559-a83c-5a2fb5f4ad25",
          amount: 4,
          measurement: "tablespoons",
          name: "white sugar",
        },
        {
          uuid: "698345bd-078d-495f-b233-df1b756dd8a7",
          amount: 2,
          measurement: "teaspoons",
          name: "baking powder",
        },
        {
          uuid: "6d4176cc-0c48-4e19-9d38-bb16578423a4",
          amount: 1,
          measurement: "teaspoon",
          name: "baking soda",
        },
        {
          uuid: "210b15ac-552e-4450-b162-c0a41bb3389d",
          amount: 1,
          measurement: "teaspoon",
          name: "salt",
        },
        {
          uuid: "3d810ba9-7e4e-48aa-b2e9-7918e38b358d",
          amount: 2,
          measurement: "",
          name: "eggs",
        },
        {
          uuid: "77ae45d7-659b-4cb5-a4ea-07f00e442974",
          amount: 4,
          measurement: "tablespoons",
          name: "butter, melted",
        },
        {
          uuid: "c8be68ed-d83b-4e6c-ba7a-082d3dc167f4",
          amount: null,
          measurement: "",
          name: "cooking spray",
        },
      ],
      directions: [
        {
          instruction:
            'Combine milk with vinegar in a medium bowl and set aside for 5 minutes to "sour".',
          optional: false,
        },
        {
          instruction:
            'Combine flour, sugar, baking powder, baking soda, and salt in a large mixing bowl. Whisk egg and butter into "soured" milk. Pour the flour mixture into the wet ingredients and whisk until lumps are gone.',
          optional: false,
        },
        {
          instruction:
            "Heat a large skillet over medium heat, and coat with cooking spray. Pour 1/4 cupfuls of batter onto the skillet, and cook until bubbles appear on the surface. Flip with a spatula, and cook until browned on the other side.",
          optional: false,
        },
      ],
    },
  ],
  specials: [
    {
      uuid: "233d8582-141a-460d-b7e1-d623afd69e7d",
      ingredientId: "62798278-2fbc-4c31-98de-b7959c191688",
      type: "event",
      title: "Bratmas Party",
      geo: "43.032446,-87.908098",
      text: "Join us at Sweet Diner for this Special Holiday Event!",
    },
    {
      uuid: "3c1aa6a4-802f-4f34-a232-bfd4d975f7b1",
      ingredientId: "3d810ba9-7e4e-48aa-b2e9-7918e38b358d",
      type: "local",
      title: "1 Dozen, 1 Dollar",
      geo: "43.044842,-87.904140",
      text: "Eggs are on sale at a grocery store near you!",
    },
    {
      uuid: "8f730f08-5ea5-48fb-bfd7-6a28337efc28",
      ingredientId: "aa1ff525-4190-4a66-8d12-3f383a752b55",
      type: "promocode",
      code: "GETMILK",
      title: "$1 off Milk",
      text: "Use the promocode GETMILK on Peapod and receive $1 off your next gallon!",
    },
    {
      uuid: "c6912eeb-f686-482d-8bf4-c118510a4069",
      ingredientId: "77ae45d7-659b-4cb5-a4ea-07f00e442974",
      type: "sale",
      title: "Eriksens Hand Rolled Butter",
      text: "Flash this recipe at a Roundy's near you and get 10% off Eriksens Hand Rolled Butter, salted or unsalted.",
    },
  ],
};
